{
  "enum": {
    "IxcCostbasisV1RealizationStatus": {
      "ACTIVE": "Active",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcCostbasisV1TaxLotStatus": {
      "CLOSED": "Closed",
      "OPEN": "Open",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxcCostbasisV1RealizationQueryServiceRealizationListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "programId": "Program",
      "realizationId": "Realization",
      "status": "Status",
      "taxLotId": "Tax Lot",
      "transactionId": "Transaction"
    },
    "IxcCostbasisV1TaxLotQueryServiceTaxLotListFilterableFields": {
      "accountId": "Account",
      "assetId": "Asset",
      "programId": "Program",
      "status": "Status",
      "taxLotId": "Tax Lot"
    }
  },
  "oneOf": {
    "IxcCostbasisV1AdjustmentTransactionTransactionType": {
      "portfolioTransaction": "Portfolio Transaction"
    },
    "IxcCostbasisV1ClosingTransactionTransactionType": {
      "portfolioTransaction": "Portfolio Transaction"
    },
    "IxcCostbasisV1OpeningTransactionTransactionType": {
      "lotSplit": "Lot Split",
      "portfolioTransaction": "Portfolio Transaction",
      "reorganization": "Reorganization"
    },
    "IxcCostbasisV1RealizationEventType": {
      "created": "Created",
      "deferLoss": "Defer Loss"
    },
    "IxcCostbasisV1TaxLotEventType": {
      "adjusted": "Adjusted",
      "closed": "Closed",
      "deferLoss": "Defer Loss",
      "exchanged": "Exchanged",
      "opened": "Opened",
      "split": "Split"
    }
  },
  "sortEnum": {
    "IxcCostbasisV1RealizationQueryServiceRealizationListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcCostbasisV1TaxLotQueryServiceTaxLotListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}